import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import './style.scss'

/**
 * 
 * @param {{
 *  editorRef?: any;
 *  value?: string;
 *  heightEditor?: any;
 *  id?: string;
 *  onChange?: (text: string) => void;
 *  inline?: boolean;
 * }} props 
 * @returns 
 */
const TinymceEditor = ({ editorRef, value, heightEditor, id, onChange, inline = false }) => {
    return (
        <Editor
            id={id}
            inline={inline}
            apiKey={process.env.REACT_APP_EDITOR_APIKEY || "frrix5f6jsh26jzcp3yucjinkqwt7olh66vj7py7el1535zu"}
            initialValue={value}
            onInit={(evt, editor) => { if (editorRef) { editorRef.current = editor } }}
            onEditorChange={(e) => {
                if (onChange) onChange(e)
            }}
            init={{
                selector: 'textarea#full-featured-non-premium',
                language: "en",
                images_upload_handler: function (blobInfo, success, failure) {
                    var xhr, formData;
                    xhr = new XMLHttpRequest();
                    xhr.withCredentials = false;
                    xhr.open('POST', `${process.env.API_ENDPOINT_UPLOAD}/api/cms-alumni/upload-file?baseFolder=${process.env.BUCKET_BASE_FOLDER ?? 'hust-cms-dev'}`);
                    xhr.onload = function () {
                        if (xhr.status !== 200) {
                            failure('Có lỗi xảy ra');
                            return;
                        }
                        success(xhr.response);
                    };
                    formData = new FormData();
                    formData.append('file', blobInfo.blob(), blobInfo.filename());
                    xhr.send(formData);
                },
                plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
                imagetools_cors_hosts: ['picsum.photos'],
                menubar: 'file edit view insert format tools table help',
                toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent | fullscreen |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | preview save print | insertfile image media template link anchor codesample | ltr rtl',
                toolbar_sticky: true,
                autosave_ask_before_unload: true,
                autosave_interval: '30s',
                autosave_prefix: '{path}{query}-{id}-',
                autosave_restore_when_empty: false,
                autosave_retention: '2m',
                image_advtab: true,
                link_list: [
                    { title: 'My page 1', value: 'https://www.tiny.cloud' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                ],
                image_list: [
                    { title: 'My page 1', value: 'https://www.tiny.cloud' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                ],
                image_class_list: [
                    { title: 'None', value: '' },
                    { title: 'Some class', value: 'class-name' }
                ],
                importcss_append: true,
                templates: [
                    { title: 'New Table', description: 'creates a new table', content: '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>' },
                    { title: 'Starting my story', description: 'A cure for writers block', content: 'Once upon a time...' },
                    { title: 'New list with dates', description: 'New List with dates', content: '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>' }
                ],
                template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
                template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',
                height: heightEditor ?? '100%',
                image_caption: true,
                quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                noneditable_noneditable_class: 'mceNonEditable',
                toolbar_mode: 'sliding',
                contextmenu: 'link image imagetools table',
                skin: 'oxide-dark',
                content_css: 'dark',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px } img {max-width: 100%;}'
            }}
        />
    )
}

export default TinymceEditor